import { connect } from "react-redux";
import { TableHeader } from "../components/TableHeader";
import { changeGlobalCheck } from "../actions/actions";
import { doSortColumn } from "../actions/thunks";
function mapStateToProps({ kptable }, { id }) {
    return {
        globalChecked: kptable[id].globalChecked,
        sortingField: kptable[id].sortingField,
        sortingDirection: kptable[id].sortingDirection,
        columnVisibility: kptable[id].columnVisibility,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onChangeGlobalCheck: (id, checked, data, keyField) => dispatch(changeGlobalCheck(id, checked, data, keyField)),
        onSortColumn: (id, sort, loaderFunc) => dispatch(doSortColumn(id, sort, loaderFunc)),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(TableHeader);
